import React from "react";
import { Label, Tag, Text } from "react-konva";
import { Zone } from "../types";
import { Offset, Scale } from "./types";

interface IProps {
  hoveredZone: number;
  offset: Offset;
  position: "above" | "below";
  scale: Scale;
  zones: ReadonlyArray<Zone>;
}
export const ZoneTag = ({ hoveredZone, offset, position, scale, zones }: IProps) => {
  const hovering = zones[hoveredZone];
  if (!hovering) {
    return null;
  }
  const { maxX, maxY, minX, minY, label } = hovering;
  const text = label.trim().toUpperCase();
  if (text.length < 1) {
    return null;
  }
  const point = {
    x: minX * scale.x + offset.x,
    y: minY * scale.y + offset.y,
  };
  const size = {
    height: (maxY - minY) * scale.y,
    width: (maxX - minX) * scale.x,
  };
  return (
    <Label x={point.x + size.width / 2} y={position === "above" ? point.y : point.y + size.height}>
      <Tag
        pointerDirection={position === "above" ? "down" : "up"}
        pointerHeight={5}
        pointerWidth={10}
        fill="black"
      />
      <Text padding={5} fill="white" fontSize={12} text={text} />
    </Label>
  );
};
